import { render, staticRenderFns } from "./UnpaidInvoiceBanner.vue?vue&type=template&id=4c253bf6&scoped=true"
import script from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
export * from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
import style0 from "./UnpaidInvoiceBanner.vue?vue&type=style&index=0&id=4c253bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c253bf6",
  null
  
)

export default component.exports